module.exports = __webpack_public_path__ + "media/images/athletes/1653-c8433545e90b991a2137222fdd26fe2f.png";